/**
 * Direct export
 */

export * from '../../../icons'
